<ion-fab vertical="bottom" horizontal="end" slot="fixed">
  <ion-button class="fab">
    <ion-icon [name]="ioniconName"></ion-icon>
    <span>{{ text }}</span>
  </ion-button>
</ion-fab>
